var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "ethical_commission" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("Этический комитет", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(_setup.MainContent, {
                    attrs: {
                      "ethical-commission-meetings":
                        _setup.context.ethical_commission_meetings,
                      "is-staff": !!_setup.context.request.user?.is_staff,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2499446990
        ),
      })
    : _c(
        "div",
        [
          _c(_setup.MainContent, {
            attrs: {
              "ethical-commission-meetings":
                _setup.context.ethical_commission_meetings,
              "is-staff": !!_setup.context.request.user?.is_staff,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }